<template>
  <div
    class="flex justify-between px-2 py-5"
    :class="{ 'bg-lexmea-selection-lightest': model }"
  >
    <div class="flex gap-2">
      <SharedSchemaIcon :shared="model" className="size-5"></SharedSchemaIcon>
      <div class="font-bold text-lexmea-blue-400">{{ title }}</div>
    </div>
    <LexmeaSwitch v-model="model"></LexmeaSwitch>
  </div>
</template>
<script setup lang="ts">
defineProps<{
  title: string;
}>();
const model = defineModel<boolean>();
</script>
